export default function initLanguageSwitch() {
  const languageSwitch = document.getElementById(
    "js-language-switch"
  ) as HTMLSelectElement;

  languageSwitch?.addEventListener("change", () => {
    window.location.href = languageSwitch.value;
  });
}
